import React from "react";
import { SLOTS_FOR, SLOT_LABEL } from "../soulumoPractice/practiceApi";
import { SlotTick } from "../soulumoPractice/PracticeDots";

// The shared rhythm in colour: which moments each day, and where the group is in the 21 days.
export const TogetherRhythm = ({ intensity, night, day = 0, dark = true }) => {
  const slots = [...(SLOTS_FOR[intensity] || []), ...(night ? ["night"] : [])];
  const text = dark ? "#e9e2d0" : "#121C33";
  return (
    <div className="mt-3" data-testid="together-rhythm">
      <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-xs" style={{ color: text }}>
        {slots.map((s) => <span key={s} className="inline-flex items-center gap-1.5" data-testid={`together-rhythm-${s}`}><SlotTick s={s} done />{SLOT_LABEL[s]}</span>)}
      </div>
      <div className="mt-3 flex gap-[3px]" aria-hidden>
        {Array.from({ length: 21 }).map((_, i) => (
          <span key={i} className="h-1.5 flex-1 rounded-full transition-colors duration-500"
            style={{ background: i + 1 < day ? "rgba(63,191,127,0.6)" : i + 1 === day ? "#f5ecd9" : dark ? "rgba(245,236,217,0.14)" : "rgba(18,28,51,0.12)" }} />
        ))}
      </div>
    </div>
  );
};
